import Image from "@tiptap/extension-image";

/**
 * Image node with optional width (resize). Stored as inline style for LMS HTML output.
 */
const CustomImage = Image.extend({
  name: "image",

  // Native image drag fights with our resize handle / selection
  draggable: false,

  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (element) => {
          const w = element.getAttribute("width");
          if (w) return /\d+%$/.test(w) || /px$/.test(w) ? w : `${w}px`;
          const s = element.style?.width;
          return s || null;
        },
        renderHTML: (attributes) => {
          if (!attributes.width) return {};
          const w = attributes.width;
          return {
            style: `width: ${w}; max-width: 100%; height: auto;`,
            "data-width": String(w),
          };
        },
      },
    };
  },
});

export default CustomImage;
